/** @jsx jsx */
import { jsx } from '@emotion/core'
import { observer } from 'mobx-react'
import React, { Fragment, useState } from 'react'
import { ListView } from 'antd-mobile'
import { UserShareBettingHistoryItem } from '@views/Home/UserPick/Components/UserShareBettingHistoryItem'
import { AdvEmpty } from '@components/AdvEmpty'
import { EMPTY_ICON } from '@constants/index'
import _ from 'lodash'
import { useOnMount } from '@utils/reactExt'
import useRootStore from '@store/useRootStore'

interface ShareBettingHistoryProps {
  baseMonth?: string
}

export const ShareBettingHistory: React.FC<ShareBettingHistoryProps> = observer((props: ShareBettingHistoryProps) => {
  const [hasMore, setHasMore] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const { chattingStore } = useRootStore()

  const { mySharedBetHistoryChatMessage } = chattingStore

  const dataSource = new ListView.DataSource({
    rowHasChanged: (row1, row2) => row1 !== row2,
  })

  useOnMount(() => {
    fetch(true)
  })

  const endReachedHandler = async () => {
    if (isLoading) {
      return
    }

    if (hasMore) {
      await fetch()
    }
  }

  const fetch = async (reset = false) => {
    try {
      setIsLoading(true)

      const params = {
        offset: reset ? 0 : _.size(mySharedBetHistoryChatMessage),
        baseMonth: props?.baseMonth,
      }
      const result = await chattingStore.api.chat.getMySharedBettingHistoryChatMessages(params)
      let messages = result.items
      if (!reset) {
        messages = _.concat(mySharedBetHistoryChatMessage, result.items)
      }
      chattingStore.setMySharedBettingHistoryChatMessages(messages)
      setHasMore(result.hasMore)
    } catch (err) {
      console.error(err)
    } finally {
      setIsLoading(false)
    }
  }

  const renderHeader = (): React.ReactElement => {
    return <Fragment/>
  }

  const renderRow = (rowData) => (
    <UserShareBettingHistoryItem chatMessage={rowData}/>
  )

  const renderFooter = () => {
    let footer
    if (_.size(mySharedBetHistoryChatMessage) > 0) {
      footer = <Fragment/>
    } else {
      footer = <AdvEmpty ico={EMPTY_ICON.SHARE_BETTING_HISTORY_LIST}/>
    }
    return <div css={{ textAlign: 'center' }}>{footer}</div>
  }

  return (
    <ListView
      className="my-share-betting-history-list-view"
      css={{ height: '100%', background: '#ddd' }}
      dataSource={dataSource.cloneWithRows(mySharedBetHistoryChatMessage ?? [])}
      renderHeader={renderHeader}
      renderRow={renderRow}
      scrollRenderAheadDistance={500}
      renderFooter={renderFooter}
      onEndReached={endReachedHandler}
      onEndReachedThreshold={10}
      initialListSize={9}
      pageSize={9}
    />
  )
})
